var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M23.25 4.547h-10.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.314l-4.608 3.584-3.304-2.102-.804 1.266 3.75 2.385c.122.078.262.117.402.117.162 0 .326-.052.46-.157l5.54-4.31v9.717h-9.75c-.414 0-.75.336-.75.75s.336.75.75.75h10.5c.414 0 .75-.336.75-.75v-12c0-.414-.336-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M13.229.22c-.171-.143-.401-.204-.617-.16l-12 2.25C.257 2.378 0 2.687 0 3.048v16.5c0 .36.257.67.612.737l12 2.25c.045.009.091.013.138.013.174 0 .344-.06.479-.172.172-.143.271-.356.271-.578v-21c0-.223-.099-.435-.271-.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M6.75 16.547c-2.067 0-3.75-2.019-3.75-4.5 0-2.48 1.683-4.5 3.75-4.5s3.75 2.02 3.75 4.5c0 2.481-1.683 4.5-3.75 4.5zm0-7.5c-1.24 0-2.25 1.346-2.25 3 0 1.655 1.01 3 2.25 3s2.25-1.345 2.25-3c0-1.654-1.01-3-2.25-3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.818f9161.svg";
export { ForwardRef as ReactComponent };